import script from "./LingoCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LingoCardComponent.vue?vue&type=style&index=0&id=650b0519&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-650b0519"]])

export default __exports__